export const MAIN_SET_LANGUAGE = 'MAIN_SET_LANGUAGE'
